import EventBusService from '../../services/EventBusService'
import { useState, useEffect, useCallback } from 'react';
import { CAMPAIGN_STATUS, NEW_CAMPAIGN_EVENT } from '../../constants';
import LocalStorage from '../../services/local-storage';

export default function CampaignTabs(props) {

    const [campaign, setCampaign] = useState(LocalStorage.get(CAMPAIGN_STATUS));

    const handleCampaignStatus = useCallback((event) => setCampaign(event.detail?.campaign), [])

    useEffect(() => {
        EventBusService.on(NEW_CAMPAIGN_EVENT, handleCampaignStatus)

        return () => {
            EventBusService.remove(NEW_CAMPAIGN_EVENT, handleCampaignStatus)
        }
    }, [handleCampaignStatus])

    return (
        <>
            {campaign &&
                <div>
                    <ul className='campaign-tabs'>
                        <li className={ props.active === 'campaign' ? 'active': ''} onClick={() => props.setTab('campaign')}>Campaign</li>
                        <li className={ props.active === 'global' ? 'active': ''}  onClick={() => props.setTab('global')}>Global</li>
                    </ul>
                </div>
            }
        </>

    )
}